import ReactDOM from "react-dom";
import React from "react";

export default function renderReactComponentInDocument(
    component: string,
    props: any,
    element: Element
): void {
    if (props) {
        ReactDOM.render(React.createElement(component, props), element);
    }
}
